import React, { Fragment, useState, useEffect } from 'react';
import './BundlePricingComponent.css'

import RatesCard from './RatesCard';
import StandardRatesComponent from './StandardRatesComponent';
import KombosComponent from './KombosComponent';
import VoiceComponent from './VoiceComponent';
import WhatsAppComponent from './Whatsapp';
import SMSComponent from './SMS';
function BundlePricingComponent(props) {
    var component = props.data.flatData;

    const [displayAmountText, setDisplayAmountText] = useState("View More Deals");
    const [displayAmountVar, setDisplayAmountVar] = useState(4);
    const [showMore, setShowMore] = useState(false);
    const [showMoreCss, setshowMoreCss] = useState("showmore");
    const [activeaccordian, setActiveaccordian] = useState(null);
    const [displayMoreActive, setDisplayMoreActive] = useState(false);



    useEffect(() => {
        if (component.virtualProductGroups && component.virtualProductGroups.length > 0) {
            if (component.virtualProductGroups[0].flatData.linkedProducts.length > 4) {
                setDisplayMoreActive(true);
            }
        }
    }, [component]);


    function handleClick(index) {
        if (activeaccordian === index) {
            setActiveaccordian(null);
        }
        else {
            setActiveaccordian(index);

        }
    }


    // Removed unused checkSize function

    function displayAmount() {
        setShowMore(!showMore);
        if (showMore) {
            setDisplayAmountVar(4);
            setDisplayAmountText("View More Deals");
            setshowMoreCss("showmore");
        }
        else {
            setDisplayAmountVar(50);
            setDisplayAmountText("View Less")
            setshowMoreCss("showless");
        }

    }
    return (
        <section className="page-layout-component" style={{ backgroundColor: (component.backgroundColor && component.backgroundColor.length > 0 ? component.backgroundColor[0].flatData.colorValue : ''), color: (component.textColor && component.textColor.length > 0 ? component.textColor[0].flatData.colorValue : '') }}>
            <section className="bundles-container">
                {component.topLeftImage && component.topLeftImage.length > 0 && component.topLeftImage[0].url.slice(0, -1) && (
                    <img className="bundletopleftimg" src={component.topLeftImage[0].url.slice(0, -1)} alt="" />
                )}
                {component.topRightImage && component.topRightImage.length > 0 && component.topRightImage[0].url.slice(0, -1) && (
                    <img className="bundletoprightimg" src={component.topRightImage[0].url.slice(0, -1)} alt="" />
                )}
                {component.botLeftImage && component.botLeftImage.length > 0 && component.botLeftImage[0].url.slice(0, -1) && (
                    <img className="bundlebottomleftimg" src={component.botLeftImage[0].url.slice(0, -1)} alt="" />
                )}
                {component.botRightImage && component.botRightImage.length > 0 && component.botRightImage[0].url.slice(0, -1) && (
                    <img className="bundlebottomrightimg" src={component.botRightImage[0].url.slice(0, -1)} alt="" />
                )}
                <h1>{component.header}</h1>
                <div className="bundles-sub-header" dangerouslySetInnerHTML={{ __html: component.subHeader }}></div>

                <div className="tabs">
                    {component.virtualProductGroups && component.virtualProductGroups.map((item, index) => {

                        return (

                            <Fragment key={index}>
                                {/* <input type="radio" name="tabs" id={'tab' + index} defaultChecked={index === 0} onClick={() => checkSize(index)} />
                                <label htmlFor={'tab' + index}>{item.flatData.description}</label> */}
                                <div className="tab" >
                                    {!item.flatData.newPriceDisplay && (
                                        <>
                                            <div className="centerdiv" dangerouslySetInnerHTML={{ __html: item.flatData.info }}></div>
                                            {item.flatData.linkedProducts && item.flatData.linkedProducts.slice(0, displayAmountVar).map((productItem, productIndex) => {
                                                if (item.flatData.linkedProducts.length > 4) {
                                                }
                                                return (

                                                    <div key={productIndex} className="bundlesaccordian ">
                                                        <div className={'accordionItem ' + (productIndex === activeaccordian ? 'open' : 'close')}>
                                                            <div className="bunacchead" onClick={() => handleClick(productIndex)}>
                                                                <div className="bunhead">
                                                                    <div className="bunname" dangerouslySetInnerHTML={{ __html: productItem.flatData.displayText }}></div>
                                                                    <div className="bunprice" dangerouslySetInnerHTML={{ __html: productItem.flatData.normalPrice }}></div>
                                                                </div>
                                                                <div className="morebenefit">View Xtra
                                                                    <div className="bunarrow"></div>
                                                                </div>
                                                            </div>
                                                            <div className="bundledetail" >
                                                                {productItem.flatData.linkedBenefits && productItem.flatData.linkedBenefits.map((benefitItem, benefitIndex) => {

                                                                    return (
                                                                        <div key={benefitIndex} className="bundle">
                                                                            {benefitItem.flatData.benefit && benefitItem.flatData.benefit.length > 0 && benefitItem.flatData.benefit[0].flatData.image && benefitItem.flatData.benefit[0].flatData.image.length > 0 && benefitItem.flatData.benefit[0].flatData.image[0].url.slice(0, -1) && (
                                                                                <img src={benefitItem.flatData.benefit[0].flatData.image[0].url.slice(0, -1)} alt="" />
                                                                            )}
                                                                            <div className="bddescription">{(benefitItem.flatData.benefit && benefitItem.flatData.benefit.length > 0 ? benefitItem.flatData.benefit[0].flatData.displayText : '')}</div>
                                                                            <div className="bdmessage" dangerouslySetInnerHTML={{ __html: (benefitItem.flatData.benefit && benefitItem.flatData.benefit.length > 0 ? benefitItem.flatData.benefit[0].flatData.displayMessage : '') }}></div>
                                                                            <div className="bdtextdisplay" dangerouslySetInnerHTML={{ __html: benefitItem.flatData.textDisplay }}></div>
                                                                        </div>
                                                                    )
                                                                })}


                                                                <div className="benefitextracontainer">
                                                                    <div className="benefitextradesc" dangerouslySetInnerHTML={{ __html: productItem.flatData.totalBenefitDescription }} ></div>
                                                                    <div className="benefitextraval" dangerouslySetInnerHTML={{ __html: productItem.flatData.totalBenefitDisplay }}></div>
                                                                </div>
                                                                <div className="benefitfooter">
                                                                    <div className="benefitfooterdesc">YOU GET</div>
                                                                    <div className="benefitfooterval" dangerouslySetInnerHTML={{ __html: productItem.flatData.allBenefitsIncludedValue }}></div>
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                            <div className="iconcontainer" onClick={displayAmount} style={{ display: displayMoreActive ? '' : 'none' }}>
                                                <div onClick={displayAmount}>{displayAmountText}</div>
                                                <div className={showMoreCss} ></div>
                                            </div>
                                        </>
                                    )}
                                    {item.flatData.newPriceDisplay && (
                                        (() => {

                                            let hasStandardRates = false;
                                            let standardRates;

                                            if (item.flatData.standardRates && item.flatData.standardRates.length > 0) {
                                                hasStandardRates = true
                                                standardRates = item.flatData.standardRates[0];
                                            }


                                            // Special prices logic removed as variables were unused
                                            return (
                                                <div className="ratesMainContainer" >
                                                    {hasStandardRates && (
                                                        <RatesCard
                                                            backgroundColor={standardRates.backgroundColor && standardRates.backgroundColor.length > 0 ? standardRates.backgroundColor[0].flatData.colorValue : ''}
                                                            logo={standardRates.logo && standardRates.logo.length > 0 ? standardRates.logo[0].url : null}
                                                            topText={standardRates.topText}
                                                            title="1 Day Data Bundle"
                                                            linkedProducts={standardRates.linkedProducts ? standardRates.linkedProducts.map(item => ({
                                                                displayText: item.flatData.displayText,
                                                                normalPrice: item.flatData.normalPrice
                                                            })) : []}
                                                            bottomImage={standardRates.bottomImage && standardRates.bottomImage.length > 0 ? standardRates.bottomImage[0].url : null}
                                                            bottomText={standardRates.bottomText}
                                                            button={standardRates.button && standardRates.button.length > 0 ? {
                                                                position: standardRates.button[0].flatData.position,
                                                                backgroundColor: standardRates.button[0].flatData.backgroundColor[0].flatData.colorValue,
                                                                buttonText: standardRates.button[0].flatData.buttonText,
                                                                secondaryText: standardRates.button[0].flatData.secondaryText
                                                            } : null}
                                                            callToAction={hasStandardRates.callToAction}
                                                            ctaColor={hasStandardRates.ctaColor && hasStandardRates.ctaColor.length > 0 ? hasStandardRates.ctaColor[0].flatData.colorValue : ""}
                                                        />
                                                    )}
                                                </div>
                                            )
                                        })()
                                    )}

                                </div>
                            </Fragment>
                        )
                    })}
                    
                    {/* Add Data tab with StandardRatesComponent */}
                    <input type="radio" name="tabs" id="dataTab" defaultChecked={true}/>
                    <label htmlFor="dataTab">Data</label>
                    <div className="tab">
                        <StandardRatesComponent />
                    </div>
                    
                    {/* Add K'ombos tab with KombosComponent */}
                    <input type="radio" name="tabs" id="kombosTab" />
                    <label htmlFor="kombosTab">Kombos</label>
                    <div className="tab">
                        <KombosComponent />
                    </div>

                         {/* Add Voice tab with VoiceComponent */}
                    <input type="radio" name="tabs" id="voiceTab" />
                    <label htmlFor="voiceTab">Voice</label>
                    <div className="tab">
                        <VoiceComponent />
                    </div>

                       {/* Add Whatsapp tab with WhatsappComponent */}
                    <input type="radio" name="tabs" id="whatsappTab" />
                    <label htmlFor="whatsappTab">WhatsApp</label>
                    <div className="tab">
                        <WhatsAppComponent />
                    </div>
                               {/* Add SMS tab with WhatsappComponent */}
                    <input type="radio" name="tabs" id="smsTab" />
                    <label htmlFor="smsTab">SMS</label>
                    <div className="tab">
                        <SMSComponent />
                    </div>
                </div>
            </section>
        </section>
    )
}

export default BundlePricingComponent;